var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("li", [
    _c("div", { staticClass: "pb-2" }, [
      _c(
        "div",
        {
          staticClass: " orgCell",
          attrs: {
            "data-id": _vm.organization.id,
            "data-parent-id": _vm.organization.parentId,
            "data-type": _vm.organization.type,
            draggable: "true"
          },
          on: { click: _vm.nodeClicked }
        },
        [
          _c("div", { staticClass: "mx-2 mt-2" }, [
            _c("div", { staticClass: "orgHeader" }, [
              _c("div", { staticClass: "orgLeft" }, [
                _vm._v(
                  "\n              " +
                    _vm._s(_vm.organization.id) +
                    "\n          "
                )
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "orgSpacer" }),
              _vm._v(" "),
              _c("div", { staticClass: "orgRight" }, [
                _vm._v(
                  "\n            " +
                    _vm._s(_vm.orgType[_vm.organization.type]) +
                    "\n          "
                )
              ])
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "orgContent" }, [
              _vm._v(
                "\n          " + _vm._s(_vm.organization.name) + "\n        "
              )
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "orgFooter" }, [
              _c("div", { staticClass: "orgLeft" }, [
                _vm._v("\n            Users: "),
                _vm.organization.id != null
                  ? _c(
                      "a",
                      {
                        staticClass: "orgAddUserLink",
                        on: {
                          click: function($event) {
                            return _vm.editUsersClick(_vm.organization)
                          }
                        }
                      },
                      [
                        _vm._v(
                          "\n              " +
                            _vm._s(
                              _vm.organization.userRelations &&
                                _vm.organization.userRelations.length > 0
                                ? _vm.organization.userRelations.length
                                : 0
                            ) +
                            "\n            "
                        )
                      ]
                    )
                  : _c("span", [_vm._v(" - ")])
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "orgSpacer" }),
              _vm._v(" "),
              _c("div", { staticClass: "orgRightActiveCount" })
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "orgFooter" }, [
              _c("div", { staticClass: "orgSpacer" }),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "orgRight" },
                [
                  _c(
                    "v-btn",
                    {
                      staticClass: "orgButton ma-1",
                      attrs: { icon: "", color: "success" },
                      on: {
                        click: function($event) {
                          return _vm.editOrganizationClick(_vm.organization)
                        }
                      }
                    },
                    [_c("v-icon", [_vm._v("mdi-pencil-outline")])],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "v-btn",
                    {
                      staticClass: "orgButton ma-1",
                      attrs: { icon: "", color: "error" },
                      on: {
                        click: function($event) {
                          return _vm.deleteOrganization(_vm.organization)
                        }
                      }
                    },
                    [_c("v-icon", [_vm._v("mdi-minus")])],
                    1
                  ),
                  _vm._v(" "),
                  _vm.organization.type == 1
                    ? _c(
                        "v-btn",
                        {
                          staticClass: "orgButton ma-1",
                          attrs: { icon: "", color: "success" },
                          on: {
                            click: function($event) {
                              return _vm.addOrganizationClick(_vm.organization)
                            }
                          }
                        },
                        [_c("v-icon", [_vm._v("mdi-plus")])],
                        1
                      )
                    : _vm._e()
                ],
                1
              )
            ])
          ])
        ]
      )
    ]),
    _vm._v(" "),
    _vm.organization.children && _vm.organization.children.length > 0
      ? _c(
          "ul",
          _vm._l(_vm.organization.children, function(child, index) {
            return _c("tree-item", {
              key: child.id,
              attrs: { organization: child }
            })
          }),
          1
        )
      : _vm._e()
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }